import { useRecoilState } from "recoil";
import { erroCapag } from "../atom";

const useErroCapagState = () => {
    return useRecoilState(erroCapag);
};

export default useErroCapagState;